import { SETTINGS_ROUTES } from "../settingProfile/settingsRoutes";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./Layout.css";
import sidebarLogo from "../assets/images/dash-logo.png";

//Import SVg
import { LockSvg, EditIconSvg, LanguageIconSvg , FavoriteState, FavoriteExam, Premuim , ResetContent, AboutSvg, ContactSvg, ReviewSvg, TermsCondition, PrivacyPolicy, PaymentDisclaimer, NotificationSvg, LogoutSvg } from '../components/SvgIcons';

const Sidebar = ({ isOpen , onLogoutClick}) => {

  const navigate = useNavigate();

  return (
    <aside className={`sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <img src={sidebarLogo} alt="Logo" className="sidebar-log" />
      </div>

      <div className="sidebar-menu">
        <p className="menu-title mb-0">General</p>
        <ul className="mb-0">
          <li> <Link to={SETTINGS_ROUTES.password}> <LockSvg/> Change Password</Link></li>
          <li> <Link to="/view-profile"> <EditIconSvg/> View Profile</Link> </li>
          <li>  <Link to={SETTINGS_ROUTES.appLanguage}>  <LanguageIconSvg/> App Language</Link> </li>
          <li>  <Link to={SETTINGS_ROUTES.contentLanguage}> <LanguageIconSvg/> Content Language</Link> </li>
        </ul>

        <p className="menu-title mb-0">Personal</p>
        <ul className="mb-0">
          <li><Link to="/choose-exam"> <FavoriteState/> Favorite States</Link></li>
          <li><Link to="/exam-cat"> <FavoriteExam/>Favorite Exams </Link></li>
          <li> <Link to="/subscription"><Premuim/> Premium </Link></li>
          {/* <li> <Premuim/> Subscription</li> */}
          <li> <ResetContent/> Reset Previous Content</li>
        </ul>

        <p className="menu-title mb-0">About</p>
        <ul className="mb-0">
          <li> <Link to="/setting-about"> <AboutSvg/> About Us </Link></li>
          <li> <ContactSvg/> Contact Us</li>
          <li> <ReviewSvg/> Reviews</li>
          <li> <TermsCondition/> Terms & Conditions</li>
          <li> <PrivacyPolicy/> Privacy Policy</li>
          <li> <PaymentDisclaimer/> Payment Disclaimer</li>
        </ul>

        <p className="menu-title mb-0">Miscellaneous</p>
        <ul className="mb-0">
          <li> <Link to={SETTINGS_ROUTES.notifications}> <NotificationSvg/> Notifications </Link> </li>
          <li  onClick={onLogoutClick}> <LogoutSvg/> Log Out</li>
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
